import { css } from '@emotion/react'
import { mdiPin, mdiPinOutline } from '@mdi/js'
import Icon from '@mdi/react'
import React from 'react'

const tiltedPin = css({ transform: 'rotate(45deg)' })

const PinIcon = React.memo((props: any) => {
    const { filled, ...other } = props
    return (
        <Icon
            data-testid="IconButton__PinButton"
            css={tiltedPin}
            path={filled ? mdiPin : mdiPinOutline}
            size={1}
            {...other}
        />
    )
})

export default PinIcon
export { PinIcon }
